import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import { P, Link } from "folksam-ui";

export default function Markdown({ source }) {
  return (
    <ReactMarkdown
      source={source}
      escapeHtml={false}
      renderers={{
        /**
         * TODO: Implement the rest of the renderers
         */
        paragraph: P,
        link: function proxyLink({ children, href }) {
          return <Link to={href}>{children}</Link>;
        }
      }}
    />
  );
}

Markdown.propTypes = {
  source: PropTypes.string.isRequired
};
